export default theme => ({
  textField: {
      maxWidth: '100%'
  },
  mobileSpace: {
    justifyContent: 'flex-start',
  },
});
